import { useTranslation } from "react-i18next";
import { Handshake } from "lucide-react";
import { useRef, useEffect } from "react";

const partners = [
  { name: "ATAScloud", image: "/ATAScloud.png" },
  { name: "Zendesk", image: "/zendesk.png" },
  { name: "Oracle Communications", image: "/ORACLE COMMUNICATIONS.png" },
  { name: "Gamatechno", image: "/GAMATEPAT.png" },
  { name: "TapHome", image: "/taphome.png" },
  { name: "LNS Teknologi", image: "/LNS.png" },
  { name: "Foorir", image: "/FOORIR.png" },
  { name: "Sunlanrfid", image: "/SUNLANRFID.png" },
  { name: "Chainway", image: "/CHAINWAY.png" },
  { name: "1stprotect", image: "/firstprotect.png" },
  { name: "Abatis365", image: "/abatis365.jpg" },
  { name: "Lumicore", image: "/lumicore.png" },
];

export default function PartnersSection() {
  const { t } = useTranslation();
  const trackRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    const slider = sliderRef.current;
    if (!track || !slider) return;

    // Clone each logo once to create a seamless infinite scroll effect.
    // Guard against React StrictMode double-invoking the effect.
    const originalCount = track.children.length;
    if (track.dataset.cloned !== "true") {
      const logos = Array.from(track.children);
      logos.forEach((logo) => {
        track.appendChild(logo.cloneNode(true));
      });
      track.dataset.cloned = "true";
    }

    // Pause animation on hover
    const handleMouseOver = () => {
      track.style.animationPlayState = "paused";
    };
    const handleMouseOut = () => {
      track.style.animationPlayState = "running";
    };

    slider.addEventListener("mouseover", handleMouseOver);
    slider.addEventListener("mouseout", handleMouseOut);

    return () => {
      slider.removeEventListener("mouseover", handleMouseOver);
      slider.removeEventListener("mouseout", handleMouseOut);
      // Remove cloned nodes so a re-mount starts clean (StrictMode / route change)
      while (track.children.length > originalCount) {
        track.removeChild(track.lastChild);
      }
      delete track.dataset.cloned;
    };
  }, []);

  return (
    <section className="py-24 tablet:py-20 px-6 mobile:px-4 bg-white hairline">
      <div className="container-page">
        <div className="mb-12 max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-11 h-11 rounded-xl bg-blueLight flex items-center justify-center">
              <Handshake className="w-5 h-5 text-textBlue" aria-hidden="true" />
            </span>
            <span className="kicker">{t("partners.label")}</span>
          </div>
          <h2 className="text-3xl tablet:text-2xl font-semibold tracking-[-0.02em] text-black mb-4">
            {t("partners.title")}
          </h2>
          <p className="text-base text-gray-600 leading-relaxed max-w-[60ch]">
            {t("partners.description")}
          </p>
        </div>

        {/* Infinite Scroll Carousel (animation preserved) */}
        <div className="logo-slider slider-mask hairline" ref={sliderRef}>
          <div className="logo-track" ref={trackRef}>
            {partners.map((partner) => (
              <img
                key={partner.name}
                src={partner.image}
                alt={partner.name}
                width="140"
                height="72"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
